var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10959 1.77778C6.10959 1.34822 5.7784 1 5.36986 1C4.96132 1 4.63014 1.34822 4.63014 1.77778V2.38272H3.72603C2.77277 2.38272 2 3.19524 2 4.19753V7.30864V13.1852C2 14.1875 2.77277 15 3.72603 15H12.274C13.2272 15 14 14.1875 14 13.1852V7.30864V4.19753C14 3.19524 13.2272 2.38272 12.274 2.38272H11.3699V1.77778C11.3699 1.34822 11.0387 1 10.6301 1C10.2216 1 9.89041 1.34822 9.89041 1.77778V2.38272H6.10959V1.77778ZM12.5205 6.53086V4.19753C12.5205 4.05435 12.4102 3.93827 12.274 3.93827H11.3699V4.54321C11.3699 4.97276 11.0387 5.32099 10.6301 5.32099C10.2216 5.32099 9.89041 4.97276 9.89041 4.54321V3.93827H6.10959V4.54321C6.10959 4.97276 5.7784 5.32099 5.36986 5.32099C4.96132 5.32099 4.63014 4.97276 4.63014 4.54321V3.93827H3.72603C3.58985 3.93827 3.47945 4.05435 3.47945 4.19753V6.53086H12.5205ZM3.47945 8.08642H12.5205V13.1852C12.5205 13.3284 12.4102 13.4444 12.274 13.4444H3.72603C3.58985 13.4444 3.47945 13.3284 3.47945 13.1852V8.08642Z",
    fill: "#7C7B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ca0e39482fa4962a1d38baa0239ce3cc.svg";
export { ForwardRef as ReactComponent };